import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../provider/user';
import { routes, SingleRoute } from '../../config/router';

type FigureCurrentPageTitleProps = {
	pathname: string;
	type: string;
	role: string;
};

export const figureCurrentPageTitle = ({ pathname, type, role }: FigureCurrentPageTitleProps) => {
	let maybeExactMatch = routes.filter(({ path }: SingleRoute) => path === pathname);

	if (maybeExactMatch.length > 1) {
		maybeExactMatch = routes.filter(
			(route: SingleRoute) => route.path === pathname && route.type === type,
		);
	}

	if (maybeExactMatch.length > 1) {
		maybeExactMatch = routes.filter(
			(route: SingleRoute) =>
				route.path === pathname && route.type === type && route.role === role,
		);
	}

	return maybeExactMatch.length ? maybeExactMatch[0].title : 'Page not found';
};

interface Props {
	title?: string;
}

export const MetaTitle = ({ title }: Props) => {
	const { pathname } = useLocation();

	const { authorized, user } = React.useContext(UserContext);

	const pageTitle = title
		? title
		: figureCurrentPageTitle({
				pathname,
				type: authorized ? 'authorized' : 'public',
				role: user !== null ? user.role : '',
		  });

	return (
		<Helmet>
			<title>{`${pageTitle} - ${process.env.REACT_APP_TITLE}`}</title>
		</Helmet>
	);
};
